__turbopack_context__.v({
  "blocksBackgroundColor": "ContributingOrganizationsWidget-module-scss-module__788IjG__blocksBackgroundColor",
  "blocksFontColor": "ContributingOrganizationsWidget-module-scss-module__788IjG__blocksFontColor",
  "container": "ContributingOrganizationsWidget-module-scss-module__788IjG__container",
  "eventsWidget": "ContributingOrganizationsWidget-module-scss-module__788IjG__eventsWidget",
  "header": "ContributingOrganizationsWidget-module-scss-module__788IjG__header",
  "imageContent": "ContributingOrganizationsWidget-module-scss-module__788IjG__imageContent",
  "secondaryNavBackgroundColor": "ContributingOrganizationsWidget-module-scss-module__788IjG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ContributingOrganizationsWidget-module-scss-module__788IjG__themeBackgroundColor",
  "themeFontColor": "ContributingOrganizationsWidget-module-scss-module__788IjG__themeFontColor",
  "themeFontFamily": "ContributingOrganizationsWidget-module-scss-module__788IjG__themeFontFamily",
  "upcomingNews": "ContributingOrganizationsWidget-module-scss-module__788IjG__upcomingNews",
  "widget": "ContributingOrganizationsWidget-module-scss-module__788IjG__widget",
});
